import { translate } from '@ott/transforms';

export const parseCardHolder = (cardHolder: string): string => translate(cardHolder);
export const formatCardHolder = (value: string) => {
  return {
    cursor: value.length,
    value,
  };
};
